<template>
  <div class="text-dark">
    <div class="flex justify-center items-center">

      <span :class="actionElementCss" @click.stop="openPickContextMenu">
          <span v-if="!todayOrYesterday">
            <span class="text-2xl font-semibold mr-2">{{journeyItem.date | weekDay}},</span>
            <span class="text-xl">{{journeyItem.date | dateWord}}</span>
          </span>
          <span v-else class="text-2xl font-semibold">
            <span>{{journeyItem.date | dateWord}}</span>
          </span>

          <span class="text-xl font-bold"> +</span>
      </span>

    <!--   <span @click.stop="openPickContextMenu" class="hover:text-warning ml-1 font-bigger cursor-pointer font-bold track-add-journal-entry">+ -->
        <!-- <feather-icon icon="PlusIcon" class="mt-1" svgClasses="h-4 w-4"/> -->
      </span>
      <PickContextMenu id="main-pick-context-menu" :ref="contextMenuId" @click="(storyType) => addJournalEntry(storyType)"/>
    <div>
    </div>
    </div>

    <div class="mb-4" v-if="$store.getters.reviewsDataLoaded && isSunday">
      <div v-if="reviewSaved">

        <SavedReview :review="review" @edit="setReviewToPupup" @delete="deleteReview">
          <!-- <vs-button size="small" @click="setReviewToPupup">edit</vs-button> -->
          <!-- <vs-button size="small" color="danger" @click="deleteReview">delete</vs-button> -->
        </SavedReview>

      </div>
      <div v-else-if="showReviewPrompt">

        <vx-card slot="no-body" class="text-center mb-2 border-3 shadow-none border-dashed">
          <feather-icon icon="CoffeeIcon" class="p-2 mb-2 inline-flex rounded-full shadow border-2 border-solid" svgClasses="h-4 w-4"></feather-icon>

          <p class="font-bold text-xl">reflect on this week</p>
          <p class="mt-2">
            Be honest with yourself about how things are going and grow through it.
          </p>
          <p class="font-italic">
            It takes only 2 minutes.
          </p>

          <vs-button size="small" @click="setReviewToPupup" class="mt-2" :class="{'animate-bounce': $route.query.addReview}">reflect</vs-button>
        </vx-card>
      </div>
    </div>

    <vx-card slot="no-body" v-if="anyGoals" v-for="goal in goals" :key="goal.id" class="text-center mb-4 border-2 shadow-none border-solid" :style="{'border-color': goal.backgroundColor}" cardBackground="">
      <feather-icon icon="AwardIcon" class="p-2 mb-2 inline-flex rounded-full shadow" :class="goal.backgroundColor ? 'text-white' : 'text-dark'" :style="{'background-color': goal.backgroundColor || 'white'}" svgClasses="h-6 w-6"></feather-icon>
      <div class="font-bold text-2xl">goal achieved</div>
      <div class="text-xl">
        the goal <span class=" text-dark font-semibold">
          <AnchoredTitle :title="goal.title" /></span> has been achieved after
        <span v-if="goal.daysTook === 1"> one day</span><span v-else>{{goal.daysTook}} days</span>
      </div>
    </vx-card>

    <vx-card slot="no-body" v-if="anyFinishedRoutines" v-for="routine in finishedRoutines" :key="routine.id" class="text-center mb-4 border-2 shadow-none border-solid" :style="{'border-color': routine.backgroundColor}" cardBackground="">
      <feather-icon icon="AwardIcon" class="p-2 mb-2 inline-flex rounded-full shadow" :class="routine.backgroundColor ? 'text-white' : 'text-dark'" :style="{'background-color': routine.backgroundColor || 'white'}" svgClasses="h-6 w-6"></feather-icon>
      <div class="font-bold text-2xl">routine accomplished</div>
      <div class="text-xl">
        the routine <span class="text-dark font-semibold">
          <AnchoredTitle :title="routine.title" /></span> has been finished
      </div>
    </vx-card>

    <vx-card v-if="!workEmpty" class="mb-4 saved_review">
      <template v-slot:title>
      <div class="m-4">
        <span class="font-bold text-black text-2xl">daily actions</span>
        <div class="flex flex-wrap">
          <div class="" v-if="anyTasks">
          <div class="font-dark font-semibold text-xl items-center"><span>tasks</span></div>
          <vs-chip v-for="task in journeyItem.tasks" :key="task.id" :color="task.backgroundColor || 'white'" class="mr-1 border border-solid" :class="{'text-dark': !task.backgroundColor, 'border-none': task.backgroundColor}">
            <AnchoredTitle :title="task.title"  />
          </vs-chip>
        </div>

        <div class="" v-if="anyRoutines">
          <div class="font-dark font-semibold text-xl items-center"><span>routines</span></div>
          <vs-chip v-for="routine in journeyItem.routines" :key="routine.id" :color="routine.backgroundColor || 'white'" class="mr-1 border border-solid" :class="{'text-dark': !routine.backgroundColor, 'border-none': routine.backgroundColor}">
             <AnchoredTitle :title="routine.title" />
          </vs-chip>
        </div>
        </div>
      </div>
    </template>

    </vx-card>

    <div v-else-if="goals.length < 1 && finishedRoutines.length < 1 && stories.length < 1" class="flex justify-center">
      <EmptyState :variant="randomVariant" :title="emptyStateTitle" :subtitle="emptyStateSubtitle" :twoColum="$store.getters.isLargeScreen && today" class="text-black" />
    </div>

    <Story class="mb-4" v-for="story in stories" :story="story" @edit="(story) => editStory(story)"  @delete="(story) => deleteStory(story)" :key="story.id"/>
    <!-- <vs-divider/> -->
  </div>

</template>

<script>
// import JourneyDay from './JourneyDay'
import * as DateHelper from '@/helpers/date'
import Review from '../Review/Review'
import SavedReview from './SavedReview'
import Story from '../Stories/Story'
import _ from 'lodash'
import { SUGGESTIONS } from './suggestions'

export default {
  components: {
    Review,
    SavedReview,
    Story
  },
  props: {
    journeyItem: {
      type: Object,
      required: true,
    }
  },
  data () {
    return {
      reviewPopupActive: false
    }
  },
  computed: {
    contextMenuId () {
      return `pickMenuId-${this.journeyItem.date.toString()}`
    },
    randomVariant () {
      return _.random(1, 4)
    },
    emptyStateSubtitle () {

      if (this.today) {
        return `You might ${SUGGESTIONS[this.$store.getters.numberForToday(SUGGESTIONS.length)]}`
      } else {
        return ''
      }
    },
    emptyStateTitle () {
      if (this.today) {
        return 'You haven\'t done anything today yet.'
      } else {
        return ''
      }
    },
    today () {
      return DateHelper.areEqual(this.journeyItem.date, DateHelper.midnight())
    },
    todayOrYesterday () {
      return this.today || DateHelper.areEqual(this.journeyItem.date, DateHelper.midnightYesterday())
    },
    goals () {
      return _.map(this.journeyItem.goals,
        (goal) => {
          return {...goal, daysTook: this.daysGoalTook(goal)}
        }
      )
    },
    finishedRoutines () {
      return _.map(this.journeyItem.finishedRoutines,
        (routine) => {
          return {...routine}
        }
      )
    },
    userRegisteredAt () {
      return DateHelper.midnight(this.$store.getters.userRegisteredAt)
    },
    anyTasks () {
      return this.journeyItem.tasks.length > 0
    },
    anyGoals () {
      return this.journeyItem.goals.length > 0
    },
    anyRoutines () {
      return this.journeyItem.routines.length > 0
    },
    anyFinishedRoutines () {
      return this.journeyItem.finishedRoutines.length > 0
    },
    workEmpty () {
      return !(this.anyTasks || this.anyRoutines)
    },
    isMobile () {
      // return true
      return this.$store.getters.isMobile
    },
    isSunday () {
      return DateHelper.isSunday(this.journeyItem.date)
    },
    showReviewPrompt () {
      return this.isSunday &&
      DateHelper.isYoungerThan(this.journeyItem.date, 16) &&
      this.$store.getters.daysFromRegistration > 3
    },
    reviewSaved () {
      return !!this.review.id
    },
    stories () {
      return this.$store.getters.getStories(
        DateHelper.midnight(this.journeyItem.date),
      )
    },
    review () {
      return this.$store.getters.getReview(
        DateHelper.midnight(this.journeyItem.date),
        DateHelper.addDays(DateHelper.midnight(this.journeyItem.date), -6),
        'week'
      )
    },
  },
  methods: {
    openPickContextMenu () {
      this.$refs[this.contextMenuId].open()
    },
    addJournalEntry (storyType) {
      this.$emit('addStoryCallback', this.journeyItem.date, storyType)
    },
    setReviewToPupup () {
      this.$emit('setReviewToPupup', this.review)
    },
    deleteStory (story) {
      this.$store.dispatch('DELETE_STORY', { story })
    },
    editStory (story) {
      this.$emit('editStory', story)
    },
    daysGoalTook (goal) {
      return Math.abs(DateHelper.datesDiff(goal.createdAt.toDate(), goal.doneOn.toDate()))
    },
    deleteReview () {
      this.$store.dispatch('DELETE_REVIEW', { review: this.review })
    },
    getStyle (element) {
      if (element.backgroundColor) {
        return {  backgroundColor: element.backgroundColor, color: 'white' }
      } else {
        return {}
      }
    },
  }
}
</script>


<style lang="scss">

.saved_review {
  .vx-card__header {
    padding: 0.6rem
  }
}

</style>
